export const SYSTEM_ALPHANUMERIC_REGEX = /^[A-Za-z]\w{2,255}$/;
export const DEPLOYMENT_ALPHANUMERIC_REGEX = /^[A-Za-z]\w{0,255}$/;
export const ENTITY_ALPHANUMERIC_REGEX = /^[A-Za-z]\w{0,30}$/;
export const PASSWORD_REGEX =
  '^.*(?=.{8,})(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#\\$%\\^&\\+=!_-]).*$';
export const LUA_KEYWORD_REGEX =  
  '^(?!(and|break|do|else|elseif|end|false|for|function|if|in|local|nil|not|or|repeat|return|then|true|until|while)$).*$';  
export const NUMERIC_REGEX = '^[0-9]*$';
export const DEPLOY_FILENAME_REGEX = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;